import { Injectable } from "@angular/core";
import { BaseClient } from "../base-client/base-client";
import { IBaseClient } from "../base-client/interface";

@Injectable({
  providedIn: 'root'
})

export class CblClient extends BaseClient implements IBaseClient {
  constructor() {
    super();
  }

  override allowedToUseCapture: boolean = true;
  override requireCxOneId: boolean = false;
}
